enum Spacing {
    Small = "16px",
    Medium = "32px",
    Large = "64px",
}

export default Spacing;